module.exports = __webpack_public_path__ + "img/civilized.9e9b701d.png";